import { useMemo } from 'react'
import { Key } from 'react-aria'
import { ListState } from 'react-stately'
import { DynamicCascadeItem, DynamicItem } from './dynamicItemUtils'

export const useCascadeSelectState = <S extends ListState<DynamicItem>>(
  state: S,
  onSelectCascadeItem: (item: DynamicCascadeItem) => void
): S => {
  const { collection, selectionManager } = state
  const modifiedSelectionManager = useMemo(() => {
    const handleSelecCascadeItem = (key: Key) => {
      const selectedDynamicItem = collection.getItem(key)?.value
      if (selectedDynamicItem?.itemType === 'cascade') {
        onSelectCascadeItem(selectedDynamicItem)
        return true
      }
      return false
    }
    const modifiedSelectionManager: typeof selectionManager = new Proxy(selectionManager, {
      get: (target, prop, receiver) => {
        switch (prop) {
          case 'toggleSelection':
            return (key: Key) => {
              if (!handleSelecCascadeItem(key)) {
                target.toggleSelection(key)
              }
            }
          case 'replaceSelection':
            return (key: Key) => {
              if (!handleSelecCascadeItem(key)) {
                target.replaceSelection(key)
              }
            }
        }
        return Reflect.get(target, prop, receiver)
      },
    })
    return modifiedSelectionManager
  }, [collection, selectionManager, onSelectCascadeItem])
  return { ...state, selectionManager: modifiedSelectionManager }
}
